export default "__VITE_ASSET__DzRKXcAH__"